import React, { useEffect, useRef, useState } from 'react';

import various from './various';
import imageIndex from '../img/imageIndex';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MenuIcon from '@material-ui/icons/Menu';
import { IconButton, ListItemIcon, makeStyles, Typography } from '@material-ui/core';
import BookOutlinedIcon from '@material-ui/icons/BookOutlined';
import { Link } from 'react-router-dom';
import { useBlogReleasePolicy } from '../domains/touzen/components/BlogReleasePolicy';

const useStyles = makeStyles((theme) => ({
  icon: {
    color: '#FFF',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  blackIcon: {
    color: '#000',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  listRoot: {
    '& > div': {
      '& > li': {
        maxHeight: '48px !important',
      },
    },
  },
  itemIcon: {
    minWidth: '40px !important',
    '& $iconRoot': {
      fill: theme.palette.primary.main,
      // fillOpacity: '0.8',
      stroke: 'white',
      width: '24px',
      height: 'auto',
    },
  },
  iconRoot: {},
  itemList: {
    fontFamily:
      '"Helvetica Neue", "Helvetica", "Hiragino Sans", "Hiragino Kaku Gothic ProN", "Arial", "Yu Gothic", "Meiryo", sans-serif',
    fontWeight: '800',
    fontSize: '0.9rem',
    fontStyle: 'italic',
    color: 'black',
  },
}));

function useHover() {
  const [hover, setHover] = useState(false);
  const ref = useRef(null);
  const handleMouseOver = () => setHover(true);
  const handleMouseOut = () => setHover(false);

  useEffect(() => {
    const node = ref.current;
    if (node) {
      node.addEventListener('mouseover', handleMouseOver);
      node.addEventListener('mouseout', handleMouseOut);

      return () => {
        node.removeEventListener('mouseover', handleMouseOver);
        node.removeEventListener('mouseout', handleMouseOut);
      };
    }
  }, []);
  return [ref, hover];
}

export default function HumburgerMenu(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [hoverRef, isHovered] = useHover();
  const [open, setOpen] = useState(false);
  const [urls, setUrls] = useState([]);
  const blogPolicy = useBlogReleasePolicy();

  const isAuth = props.isAuth;
  const canManageBlog = Boolean(isAuth && blogPolicy.can_manage);
  const showBlog = blogPolicy.public_release || canManageBlog;
  const permissions = React.useMemo(
    () => (Array.isArray(props.permissions) ? props.permissions : []),
    [props.permissions]
  );

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  useEffect(() => {
    if (isHovered) {
      setAnchorEl(hoverRef.current);
      setOpen(true);
    }
  }, [isHovered, hoverRef]);

  useEffect(() => {
    let timeoutId;
    if (open) {
      const elm = document.getElementById('simple-menu');
      if (!elm) return;
      elm.onmousemove = (event) => {
        if (timeoutId) return;
        timeoutId = setTimeout(() => {
          timeoutId = 0;
          // 要素の座標を取得
          const target = document.getElementsByClassName('MuiList-root')[0];
          if (!target || !hoverRef.current) return;
          let targetCoordinate = target.getBoundingClientRect();
          // mouseLeave的Event発火
          const adjustableHeight =
            hoverRef.current.getBoundingClientRect().height;
          if (
            event.clientX < targetCoordinate.x &&
            event.clientY > adjustableHeight + targetCoordinate.y
          ) {
            setAnchorEl(null);
            setOpen(false);
          }
        }, 100);
      };
      return () => { clearTimeout(timeoutId); elm.onmousemove = null; };
    }
  }, [open, hoverRef]);

  useEffect(() => {
    const adminView = ['MYPAGE', 'ManagedIndex'];
    const staffView = ['MYPAGE', 'IMAGEUPDATE'];
    const instructorView = [
      'MYPAGE',
      'SeminarIndex',
      'InstructorSettingsForInstructor',
      'DocumentIndex',
    ];
    const generalView = ['MYPAGE'];
    const memberOfGroupView = ['MYPAGE'];

    const result = [];
    for (const url of various.globalNavUrls) {
      if (url.name === 'BLOG' && !showBlog) continue;
      // console.log('url', url);
      if (!url.auth) {
        if (isAuth && url.name === 'LOGIN') {
          continue;
        } else {
          result.push(url);
        }
      } else if (!isAuth && url.auth) {
        continue;
      }

      if (isAuth && url.auth) {
        if (url.name === 'BlogManage') {
          if (canManageBlog) result.push(url);
          continue;
        }
        if (url.name === 'LOGOUT') {
          result.push(url);
          continue;
        }
        if (permissions.length > 0) {
          if (permissions.includes('admin')) {
            if (adminView.includes(url.name)) {
              result.push(url);
            }
          } else if (permissions.includes('staff')) {
            if (staffView.includes(url.name)) {
              result.push(url);
            }
          } else if (
            permissions.includes('instructor') ||
            permissions.includes('seminar_staff') ||
            permissions.includes('organizer')
          ) {
            if (instructorView.includes(url.name)) {
              result.push(url);
            }
          } else if (permissions.includes('member_of_group')) {
            if (memberOfGroupView.includes(url.name)) {
              result.push(url);
            }
          } else if (permissions.includes('general')) {
            if (generalView.includes(url.name)) {
              result.push(url);
            }
          }
        }
      }
    }
    setUrls(result);
  }, [isAuth, permissions, canManageBlog, showBlog]);

  const routing = (urls) => {
    const result = [];
    urls.forEach((url, index) => {
      if (url.name === 'BLOG' && !showBlog) return;
      if (url.name === 'BlogManage' && (!isAuth || !canManageBlog)) return;
      const Icon = imageIndex.humMenu[url.name.toLowerCase()] || BookOutlinedIcon;
      const label = (
        <Typography className={classes.itemList} variant="inherit">
          {url.viewName}
        </Typography>
      );
      result.push(
        <MenuItem
          key={index}
          component={Link} to={url.path}
          onClick={handleClose}
        >
          <ListItemIcon classes={{ root: classes.itemIcon }}>
            <Icon classes={{ root: classes.iconRoot }} />
          </ListItemIcon>
          {label}
        </MenuItem>
      );
    });
    return result;
  };

  return (
    <div ref={hoverRef}>
      <IconButton aria-label="メニューを開く" aria-controls="simple-menu" aria-haspopup="true"
        aria-expanded={Boolean(anchorEl)} onClick={handleClick}
        className={props.isShown ? classes.blackIcon : classes.icon}>
        <MenuIcon fontSize="medium" />
      </IconButton>
      <Menu
        id="simple-menu"
        classes={{ list: classes.listRoot }}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {routing(urls)}
      </Menu>
    </div>
  );
}
